import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanDependenciesRoute: InvariantJiraRoute = {
	name: 'software-plan-dependencies',
	path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies',
};
